module.exports = __webpack_public_path__ + "static/media/soils_overview_2.4de56dcf.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_overview_2.png
// module id = 1287
// module chunks = 0